module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n    " + _vm._s(_vm.channelDisplayFlag) + "\n    "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "col-xs-12 align-center",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textSectionActualMeasurement[_vm.actualLanguage]))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "chartData": _vm.crunchedMaxCurrent
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d248209","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/PieChartPowerAverage.vue
// module id = 1491
// module chunks = 4